import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useAutoFormBuilding } from 'app/modules/wallforming/components/auto-form/hooks/useAutoFormBuilding';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';
import { EMPTY_GUID } from 'shared/constants';

export const AUTO_FORM_SEARCH_PARAM = 'autoform';

/** Runs auto-forming once the session requested via `?autoform=1` has loaded its POIs (PDF → IFC → formwork in one step). */
export const AutoFormOnSessionLoad = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const runAutoForm = useAutoFormBuilding();
    const isRequested = searchParams.get(AUTO_FORM_SEARCH_PARAM) === '1';
    const sessionId = searchParams.get('formingsession');
    const hasPois = usePlacementStore((state) => state.pois.some(({ poi }) => poi.poiGuid !== EMPTY_GUID));
    const startedFor = useRef<string | null>(null);

    useEffect(() => {
        if (!isRequested || !hasPois || !sessionId || startedFor.current === sessionId) {
            return;
        }

        startedFor.current = sessionId;
        const nextParams = new URLSearchParams(searchParams);
        nextParams.delete(AUTO_FORM_SEARCH_PARAM);
        setSearchParams(nextParams, { replace: true });
        void runAutoForm();
    }, [hasPois, isRequested, runAutoForm, searchParams, sessionId, setSearchParams]);

    return null;
};
